<template>
    <div class="modal fade" tabindex="-1" :id="id">
        <div class="modal-dialog modal-md">
          <form id="kt_modal_form_project" @submit.prevent="submitForm" class="form mt-5" >
            <div class="modal-content">
              <div class="modal-header">
                <h5 class="modal-title">{{ $t('tasks.addAttachFile') }}</h5>
                <div class="btn btn-icon btn-sm btn-active-light-primary ms-2" data-bs-dismiss="modal" aria-label="Close">
                  <span class="svg-icon svg-icon-1">
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                      <rect opacity="0.5" x="6" y="17.3137" width="16" height="2" rx="1" transform="rotate(-45 6 17.3137)"
                            fill="currentColor"/>
                      <rect x="7.41422" y="6" width="16" height="2" rx="1" transform="rotate(45 7.41422 6)"
                            fill="currentColor"/>
                    </svg>
                  </span>
                </div>
              </div>
              <div class="modal-body scroll-y" style="max-height: 75vh">
                <div class="row">
                  <DropFileZone
                      :id="`${id}_upload_file`"
                      :files="formData.files"
                      @addFiles="addFiles"
                      @removeFiles="removeFiles"
                  />
                </div>
              </div>
              <div class="modal-footer">
                <Button type="cancel" id="cancel_btn" btn-class="btn-sm me-3" size="7px 30px" btn-text="button.cancel" @click.prevent="closeModal"></Button>
                <Button btn-class="btn-sm me-3" type="submit" id="submit_btn" btn-text="button.save" size="7px 30px" :is-loading="loading" :disabled="!formData.files.length"></Button>
              </div>
            </div>
          </form>
        </div>
      </div>
</template>

<script setup>

import { defineProps, ref, watch } from 'vue';
import { useStore } from "vuex";
import Button from "@/components/Button.vue"
import {useLocales} from "@/composables/locales";
import UploadFile from "@/components/UploadFile.vue";
import DropFileZone from "@/components/DropFileZone.vue";


const emits = defineEmits(['callback'])

const props = defineProps({
  taskId: String,
  id:{type: String, required: true}
})

const store = useStore()
const { locale } = useLocales()

const formData = ref({
  task_id: props.taskId,
  files: []
})
const loading = ref(false)


watch(() => props.taskId, (newVal) => {
  if (newVal) {
    formData.value = {
      task_id: newVal,
      files: []
    }
  }
}, { immediate: true })

function resetForm() {
  formData.value = {
    task_id: props.taskId,
    files: []
  }
}

function closeModal() {
  $('#'+props.id).modal('toggle')
}

function addFiles(files){
  for(let file of files) {
    formData.value.files.push(file)
  }
}

function removeFiles(index) {
  formData.value.files.splice(index, 1)
}

const uploadTaskFile = () => submitForm()

function submitForm() {
  loading.value = true
  store.dispatch('files/uploadTaskFiles', formData.value)
      .then(() => {
        closeModal()
        resetForm()
        emits('callback')
      })
      .catch()
      .finally(() => loading.value = false)
}



</script>
